import React, {Component, PropTypes} from 'react';
import {I18N} from '../../../globals/config';
import classNames from 'classnames';

class AssignmentSearchResult extends Component {
	render(){
		var Post = this.props.Post;
		var date = new Date( Post.date );
		var classes = classNames({
			'assignment' : true,
			'search-result' : true
		});
		return (
			<div className={classes} onClick={this._select_assignment.bind( this, Post)}>
				<h1 className="entry-title">
					{Post.title.rendered}
				</h1>
				<content>
					{I18N.last_assigned}: &nbsp;
					<time dateTime={date.format( 'c')}>
						{date.format( 'M d, Y' )}
					</time>
				</content>
			</div>
		)
	}

	_select_assignment( Post ){
		//fake element to give the edspire js something to read from
		var $element = '<span data-post="' + Post.id + '"/>';
		EdspireGrunt.D.note_assignment_forms.populate_edit_form.call( $( $element ), false );
		var close = function(){
			this.props.form.props.close();
		}.bind( this );
		EdspireGrunt.el.doc.unbind( 'populate-edit-form-complete' );
		EdspireGrunt.el.doc.on( 'populate-edit-form-complete', close );
	}
}

AssignmentSearchResult.propTypes = {
	Post : PropTypes.object.isRequired,
	form : PropTypes.object.isRequired
};

export default AssignmentSearchResult;


// WEBPACK FOOTER //
// ./src/components/modals/search/assignment-search-result.js